// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__sGY8L","errorContainer":"style_errorContainer__V0mA+","paper":"style_paper__NjhUR"};